import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import Cookies from "js-cookie";
import { formatBuildingLabel } from "../utils/apartmentDisplay";

const ConfirmInfoModal = ({
  isOpen,
  onClose,
  onConfirm,
  formData,
  isCoOwnerInfo = false,
  isSubmissionCheck = false,
  isApplicantInfo = false,
}) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
          padding: "20px",
        }}
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          style={{
            backgroundColor: "white",
            borderRadius: "16px",
            padding: "24px",
            width: "100%",
            maxWidth: "400px",
            boxShadow:
              "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* 헤더 */}
          <div style={{ textAlign: "center", marginBottom: "24px" }}>
            <h2
              style={{
                fontSize: "20px",
                fontWeight: "600",
                color: "#1F2937",
                margin: "0 0 8px 0",
              }}
            >
              {isApplicantInfo
                ? "신청자 정보 확인"
                : isCoOwnerInfo
                ? "공동소유자 정보 확인"
                : isSubmissionCheck
                ? "접수내역 확인 정보"
                : "입력 정보 확인"}
            </h2>
            <p
              style={{
                fontSize: "14px",
                color: "#6B7280",
                margin: 0,
              }}
            >
              {isApplicantInfo
                ? "입력하신 신청자 정보를 확인해주세요"
                : isCoOwnerInfo
                ? `총 ${formData.totalCount}명의 공동소유자 정보를 확인해주세요`
                : isSubmissionCheck
                ? "입력하신 정보로 접수내역을 확인합니다"
                : "입력하신 정보를 확인해주세요"}
            </p>
          </div>

          {/* 정보 표시 */}
          <div style={{ marginBottom: "24px" }}>
            {isApplicantInfo || isCoOwnerInfo ? (
              // 공동소유자 정보 표시
              <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                {formData.coOwners.map((coOwner, index) => (
                  <div
                    key={coOwner.id}
                    style={{
                      backgroundColor: "#F9FAFB",
                      borderRadius: "12px",
                      padding: "16px",
                      marginBottom:
                        index < formData.coOwners.length - 1 ? "12px" : "0",
                    }}
                  >
                    <div style={{ marginBottom: "12px" }}>
                      <label
                        style={{
                          fontSize: "14px",
                          color: "#6B7280",
                          fontWeight: "600",
                          marginBottom: "8px",
                          display: "block",
                        }}
                      >
                        {isApplicantInfo ? "" : `공동소유자 ${coOwner.id}`}
                      </label>
                    </div>

                    <div style={{ marginBottom: "8px" }}>
                      <label
                        style={{
                          fontSize: "12px",
                          color: "#6B7280",
                          fontWeight: "500",
                          marginBottom: "4px",
                          display: "block",
                        }}
                      >
                        이름
                      </label>
                      <div
                        style={{
                          fontSize: "16px",
                          color: "#1F2937",
                          fontWeight: "500",
                        }}
                      >
                        {coOwner.name || "-"}
                      </div>
                    </div>

                    <div style={{ marginBottom: "8px" }}>
                      <label
                        style={{
                          fontSize: "12px",
                          color: "#6B7280",
                          fontWeight: "500",
                          marginBottom: "4px",
                          display: "block",
                        }}
                      >
                        연락처
                      </label>
                      <div
                        style={{
                          fontSize: "16px",
                          color: "#1F2937",
                          fontWeight: "500",
                        }}
                      >
                        {coOwner.phone || "-"}
                      </div>
                    </div>

                    <div>
                      <label
                        style={{
                          fontSize: "12px",
                          color: "#6B7280",
                          fontWeight: "500",
                          marginBottom: "4px",
                          display: "block",
                        }}
                      >
                        생년월일
                      </label>
                      <div
                        style={{
                          fontSize: "16px",
                          color: "#1F2937",
                          fontWeight: "500",
                        }}
                      >
                        {coOwner.birthDate || "-"}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              // 동/호수/신청인명 정보 표시 (KakaoLoginPage용)
              <div
                style={{
                  backgroundColor: "#F9FAFB",
                  borderRadius: "12px",
                  padding: "20px",
                }}
              >
                <div style={{ marginBottom: "20px", textAlign: "center" }}>
                  <div
                    style={{
                      fontSize: "20px",
                      color: "#1F2937",
                      fontWeight: "600",
                      marginBottom: "8px",
                    }}
                  >
                    {formatBuildingLabel(
                      formData.building,
                      Cookies.get("apartmentCode"),
                    )}{" "}
                    {formData.unit}호
                  </div>
                </div>

                <div>
                  <label
                    style={{
                      fontSize: "14px",
                      color: "#6B7280",
                      fontWeight: "500",
                      marginBottom: "8px",
                      display: "block",
                    }}
                  >
                    신청인명
                  </label>
                  <div
                    style={{
                      fontSize: "18px",
                      color: "#1F2937",
                      fontWeight: "600",
                      textAlign: "center",
                      padding: "12px",
                      backgroundColor: "#FFFFFF",
                      borderRadius: "8px",
                      border: "1px solid #E5E7EB",
                    }}
                  >
                    {formData.applicantName || "-"}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* 버튼 영역 */}
          <div
            style={{
              display: "flex",
              gap: "12px",
            }}
          >
            <button
              onClick={onClose}
              style={{
                flex: 1,
                height: "48px",
                backgroundColor: "#F3F4F6",
                color: "#6B7280",
                border: "none",
                borderRadius: "12px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "background-color 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#E5E7EB";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#F3F4F6";
              }}
            >
              수정하기
            </button>
            <button
              onClick={onConfirm}
              style={{
                flex: 1,
                height: "48px",
                backgroundColor: "#7A4FFF",
                color: "white",
                border: "none",
                borderRadius: "12px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "background-color 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#6A35E5";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#7A4FFF";
              }}
            >
              {isCoOwnerInfo
                ? "확인"
                : isSubmissionCheck
                ? "접수내역 확인"
                : "확인"}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ConfirmInfoModal;
